import {
  getTokenListing,
  getCheapestTokenListing,
  getfilterData,
  getFilterMarketPlaceData,
  searchBy,
} from "api/api";
import * as icon from "../../services/icon";

export const FETCH_GANGSTA_REQUEST = "FETCH_GANGSTA_REQUEST";
export const FETCH_GANGSTA_RECEIVED = "FETCH_GANGSTA_RECEIVED";
export const FETCH_GANGSTA_FAIL = "FETCH_GANGSTA_FAIL";
export const FETCH_FILTER_DATA_REQUEST = "FETCH_FILTER_DATA_REQUEST";
export const FETCH_FILTER_DATA_FAIL = "FETCH_FILTER_DATA_FAIL";
export const FETCH_FILTER_DATA_RECEIVED = "FETCH_FILTER_DATA_RECEIVED";
export const FETCH_QUERY_RECIEVED = "FETCH_QUERY_RECIEVED";
export const SET_CURRENT_PAGE = "SET_PAGE";
export const FETCH_ACCUMULATED_GBET_PENDING = "FETCH_ACCUMULATED_GBET_PENDING";
export const FETCH_ACCUMULATED_GBET_RECEIVED =
  "FETCH_ACCUMULATED_GBET_RECEIVED";
export const FETCH_ACCUMULATED_GBET_FAIL = "FETCH_ACCUMULATED_GBET_FAIL";

export const fetchAccumulatedGBETStart = () => {
  return {
    type: FETCH_ACCUMULATED_GBET_PENDING,
  };
};
export const fetchAccumulatedGBETSuccess = (response) => {
  return {
    type: FETCH_ACCUMULATED_GBET_RECEIVED,
    data: response,
  };
};

export const fetchAccumulatedGBETFail = (error) => {
  return {
    type: FETCH_ACCUMULATED_GBET_FAIL,
    error: error,
  };
};

export const fetchAccumulatedGBETs = (tokens) => {
  console.log(tokens);
  return async (dispatch) => {
    try {
      dispatch(fetchAccumulatedGBETStart());
      let list = {};
      console.log("hey");
      if (tokens) {
        for (let i = 0; i < tokens.length; i++) {
          const balance = await icon.getGbetBalance(tokens[i]["token_id"]);
          list[tokens[i]["token_id"]] = balance;
        }
      }
      console.log(list);
      dispatch(fetchAccumulatedGBETSuccess(list));
    } catch (error) {
      console.log(error);
      dispatch(fetchAccumulatedGBETFail(error));
    }
  };
};

export const fetchMarketPlaceError = (error) => {
  return {
    type: FETCH_GANGSTA_FAIL,
    error: error,
  };
};

export const fetchMarketPlaceRecieved = (data) => {
  return {
    type: FETCH_GANGSTA_RECEIVED,
    data: data,
  };
};

export const fetchMarketPlaceQuery = (data) => {
  return {
    type: FETCH_QUERY_RECIEVED,
    data: data,
  };
};

export const setCurrentPage = (data) => {
  return {
    type: SET_CURRENT_PAGE,
    data: data,
  };
};

export const fetchMarketPlaceData = (page) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_GANGSTA_REQUEST });

      const marketplaceData = await getTokenListing(page);
      console.log("fetching gbet");
      dispatch(fetchAccumulatedGBETs(marketplaceData.data.tokens));
      dispatch(fetchMarketPlaceRecieved(marketplaceData.data));
    } catch (error) {
      dispatch(fetchMarketPlaceError(error));
    }
  };
};

export const fetchFilterDataError = (error) => {
  return {
    type: FETCH_FILTER_DATA_FAIL,
    error: error,
  };
};

export const fetchFilterDataRecieved = (data) => {
  return {
    type: FETCH_FILTER_DATA_RECEIVED,
    data: data,
  };
};

export const fetchFilterData = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_FILTER_DATA_REQUEST });

      const response = await getfilterData();

      dispatch(fetchFilterDataRecieved(response.data));
    } catch (error) {
      dispatch(fetchFilterDataError(error));
    }
  };
};

export const fetchMarketPlaceFilterData = (page, query) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_GANGSTA_REQUEST });
      const response = await getFilterMarketPlaceData(page, query);
      dispatch(fetchAccumulatedGBETs(response.data.tokens));
      dispatch(fetchMarketPlaceRecieved(response.data));
    } catch (error) {
      dispatch(fetchMarketPlaceError(error));
    }
  };
};

export const fetchMarketPlaceSearchData = (page, query) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_GANGSTA_REQUEST });
      const response = await searchBy(page, query);
      dispatch(fetchAccumulatedGBETs(response.data.tokens));
      dispatch(fetchMarketPlaceRecieved(response.data));
    } catch (error) {
      dispatch(fetchMarketPlaceError(error));
    }
  };
};
